module.exports = __webpack_public_path__ + "static/TheColourLoungeScreenshot-5b479b8f00b99329595a60623c33daee.png";